import { useModal } from '@adserve/adserve-react-components';
import React, { useContext, useEffect } from 'react';
import { AirtimePlanningContext } from '../../../contexts/AirtimePlanningContext';
import { DeleteCampaignBurst, GetCampaignBursts } from '../../../services/CampaignsDataService';
import AirtimeBursts from '../AirtimeBursts/AirtimeBursts';
import { cancelMessageButtonStyle, okMessageButtonStyle } from '../CampaignStyles';

const AirtimeSettings = ({
    campaign,
    readOnly,
    changeMade
}) => {
    const { campaignBursts, setCampaignBursts } = useContext(AirtimePlanningContext);
    const { addMessage } = useModal();

    useEffect(() => {
        GetCampaignBursts(campaign?.id).then((data) => {
            setCampaignBursts(data);
        });
        if (!campaign.advancedOptions) {
            campaign.advancedOptions = {};
        }
        if (!campaign.advancedOptions.airTimeStartDate) {
            campaign.advancedOptions.airTimeStartDate = campaign.startDate;
            campaign.advancedOptions.airtimeEndDate = campaign.endDate;
        }
    }, [campaign]);

    const handleDeleteCampaignBurst = (campaignBurst) => {
        addMessage({
            message: window.translate(`Are you sure you want to delete ${campaignBurst.name}?`),
            buttons: [
                {
                    text: window.translate('No'),
                    style: cancelMessageButtonStyle,
                    callback: null
                },
                {
                    text: window.translate('Yes'),
                    style: okMessageButtonStyle,
                    callback: () => DeleteCampaignBurst(campaignBurst.id).then(() => {
                        GetCampaignBursts(campaign?.id).then((data) => {
                            setCampaignBursts(data);
                        });
                    })
                }
            ]
        });
    } ;

    return (
        <div>
            <AirtimeBursts
                campaign={campaign}
                readOnly={readOnly}
                campaignBursts={campaignBursts}
                deleteBurst={handleDeleteCampaignBurst}
            />
        </div>
    );
};
export default AirtimeSettings;
